import currency from 'currency.js'

export default {
    data () {
        return {
            camposATotalizar: [],
            campoTotal: '',
            TotalGeral: 0.00,
        }
    },
    computed: {
        totalCalculado () {
            this.TotalGeral = this.camposATotalizar.reduce((a, c) => (currency(a)).add(c.valorFormatado), 0)
            return this.TotalGeral.value
        },
    },
    watch: {
        totalCalculado(v) {
            this.campoTotal.valorTemporario = v
        }
    },
    methods: {
        setupTotalizador(campo, elementos) {
            this.campoTotal = campo

            elementos.forEach((e) => {
                if(e.atualizarTotal == true) {
                    this.camposATotalizar.push(e)
                }
            })
        }
    }
}
